import {lazy} from 'react';

export const IntroPageAsync = lazy(() => import('./IntroPage'));
